import { Grid } from "@mui/material";
import { DropDown } from "components/UI";
import { FORM_DEFAULT_R_PACKAGE_CATALOG } from "pages/Report/constants/constants";
import { ResponseText } from "utils/5xxResponseText";
import axios from "configs/axiosConfig";
import { responseErrors } from "utils";
import React, { useEffect, useState } from "react";
import ButtonAction from "../ButtonAction";
import {
  useExcelDownloadOnlineMutation,
  useReportCommonGetRPackageOwnerQuery,
  useReportCommonRPackageCategoryListQuery,
} from "shared/services/report";
import { useLoadingContext } from "shared/contexts/LoadingContext";
import { useGenSignedUrlMutation } from "shared/services/common/monitoring";
import { useSelector } from "react-redux";
import { COMMON_ENUM } from "shared/constants";

export default function RPackageCatalogReport(props) {
  const userInfo = useSelector(state => state.auth.user);
  const [form, setForm] = useState(FORM_DEFAULT_R_PACKAGE_CATALOG);

  const { data: rPkgOwnerList } = useReportCommonGetRPackageOwnerQuery();
  const { data: rPkgCategoryList } = useReportCommonRPackageCategoryListQuery();

  const [disabledSubmitBtn, setDisabledSubmitBtn] = useState(false);
  const generateReport = useExcelDownloadOnlineMutation();
  const genSignedUrl = useGenSignedUrlMutation();
  const { startLoading, stopLoading } = useLoadingContext();
  const BaseServicePath = process.env.REACT_APP_API_COMMON;

  const handleDownloadS3File = async (event, item) => {
    try {
      const targetLink = event.target.getAttribute("href");
      let expires = 0;

      if (targetLink && targetLink.startsWith("http")) {
        const url = new URL(targetLink);
        expires = (+url.searchParams.get("Expires") || 0) * 1000;
      }

      if (Date.now() > expires) {
        const result = await genSignedUrl({ key: item.pathName });
        window.open(result.data.url, "_blank");
        // const link = document.createElement("a");
        // link.href = result.url;
        // link.setAttribute("download", "");
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
      }
    } catch (error) {
      const errors = reportError(error);
      props.setMsgError(errors);
    }
  };

  const handleDownload = async e => {
    try {
      props.setMsgError([]);
      props.setMsgAlert([]);
      const body = {
        userId: userInfo.userName,
        displayName: userInfo.displayName,
        dataOwner: COMMON_ENUM.C_SM_CTG_TMAP_EM,
        userLocation: userInfo.companyAbbr,
        rPackageOwner: form?.rPkgTypeOwner,
        rPackageCategory: form?.rPkgTypeCategory,
      };
      const pathReport = "generate-r-package-catalog-report";
      startLoading();
      const { data } = await generateReport(body, pathReport);
      waitAndDownloadExcel(60, data, props.setMsgError, stopLoading, e);
      setDisabledSubmitBtn(false);

      return;
    } catch (error) {
      const msgError = responseErrors(error);
      props.setMsgError(msgError);
      setDisabledSubmitBtn(false);
      stopLoading();
    }
  };

  const waitAndDownloadExcel = (limit, response, setMsg, stopLoading, e) => {
    const timer = 2;
    let count = 0;

    const { docId } = response?.result;
    const state = setInterval(async () => {
      count += timer;
      try {
        if (count >= limit) {
          clearInterval(state);
          console.error("TimeOut");
          setMsg([`${ResponseText[504]}`]);
          stopLoading();
          throw new Error("TimeOut");
        }
      } catch (error) {
        clearInterval(state);
        console.error("An error occurred while checking the download status:", error);
        setMsg([`An error occurred while checking the download status:, ${error}`]);
        stopLoading();
        return error;
      }

      try {
        const fileStatus = await axios({
          url: `${process.env.REACT_APP_API_URL}${BaseServicePath}/download/status?docId=${docId}`,
          method: "GET",
        });

        const { data } = fileStatus;

        if (data?.status === "3") {
          clearInterval(state);
          await handleDownloadS3File(e, response.result);
        } else if (data?.status === "6") {
          clearInterval(state);
          setMsg([`${ResponseText[500]}`]);
        }
        stopLoading();
        return;
      } catch (error) {
        stopLoading();
        clearInterval(state);
        const msg = responseErrors(error);
        setMsg(msg);
        return;
      }
    }, timer * 1000);
  };

  useEffect(() => {
    document.getElementById("select-rpackage-owner").focus();
  }, []);

  return (
    <Grid container>
      <Grid item xs={5} style={{ display: "flex" }}>
        <strong style={{ margin: "auto 0px", width: "300px" }}>*Report : </strong>
        <DropDown
          id="select-report"
          fullWidth
          required
          defaultValue=""
          placeholder="<All>"
          menu={[{ key: "1", value: "R-Package Catalog Report" }]}
          value={form?.reportId}
          disabled
        />
      </Grid>
      <Grid item xs={7} />
      <Grid item xs={5} style={{ display: "flex", paddingTop: "6px", marginBottom: "15px" }}>
        <strong style={{ margin: "auto 0px", width: "300px" }}>R-Package Owner : </strong>
        <DropDown
          id="select-rpackage-owner"
          fullWidth
          value={form?.rPkgTypeOwner}
          defaultValue=""
          placeholder="<All>"
          menu={rPkgOwnerList?.map(val => ({
            key: val.rPkgOwnerCompAbbr,
            value: val.rPkgOwnerCompAbbr,
          }))}
          onChange={e =>
            setForm(old => ({
              ...old,
              rPkgTypeOwner: e.target.value,
            }))
          }
        />
      </Grid>
      <Grid item xs={1} />
      <Grid item xs={5} style={{ display: "flex", paddingTop: "6px", marginBottom: "15px" }}>
        <strong style={{ margin: "auto 0px", width: "300px" }}>R-Package Category : </strong>
        <DropDown
          id="select-rpackage-category"
          fullWidth
          value={form?.rPkgTypeCategory}
          defaultValue=""
          placeholder="<All>"
          menu={rPkgCategoryList?.map(val => ({
            key: val.cd,
            value: val.value,
          }))}
          onChange={e =>
            setForm(old => ({
              ...old,
              rPkgTypeCategory: e.target.value,
            }))
          }
        />
      </Grid>
      <Grid item xs={1} />

      <ButtonAction
        handleDownload={handleDownload}
        setFrom={setForm}
        defaultFrom={FORM_DEFAULT_R_PACKAGE_CATALOG}
        disabled={disabledSubmitBtn}
        setDisabled={setDisabledSubmitBtn}
        clearMsg={() => {
          props.setMsgAlert([]);
          props.setMsgError([]);
        }}
        firstField={"select-rpackage-owner"}
      />
    </Grid>
  );
}
